module.exports = __webpack_public_path__ + "static/media/Legacy-Youth-Fighters-2023.03001073.jpg";